import React from 'react';
import BenefitGrid from './BenefitGrid';
import SEOHead from './SEOHead';
import './Home.css';

const Home = React.memo(({ benefits, loading, error, retry }) => {
  return (
    <>
      <SEOHead
        title="Monkey Beneficios - Descubre beneficios exclusivos"
        description="Accede a beneficios exclusivos para tu bienestar. Descuentos en gimnasios, meditación, alimentación saludable y más con MonkeyFit."
        keywords="beneficios, descuentos, fitness, bienestar, monkeyfit, gimnasio, meditación, alimentación saludable"
      />
      <div className="home">
        <header className="hero">
          <div className="hero__content">
            <h1 className="hero__title">Beneficios exclusivos para la comunidad MonkeyFit</h1>
            <p className="hero__description">
              Descubre descuentos, experiencias y beneficios especiales de marcas alineadas con nuestro propósito.
            </p>
          </div>
        </header>
        <section className="benefits" aria-label="Beneficios destacados">
          <div className="benefits__container">
            <h2 className="benefits__title">Todos los beneficios</h2>
            <p className="benefits__subtitle">
              Explora todos los descuentos disponibles para ti
            </p>
            <BenefitGrid benefits={benefits} loading={loading} error={error} retry={retry} />
          </div>
        </section>
      </div>
    </>
  );
});

Home.displayName = 'Home';

export default Home;
